var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector63X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.581,35.515C6.322,35.762 6.005,35.922 5.666,35.978C5.328,36.034 4.982,35.982 4.669,35.83C4.356,35.677 4.089,35.43 3.9,35.116C3.71,34.803 3.606,34.437 3.6,34.061L3.6,29.631C2.645,29.631 1.73,29.214 1.054,28.473C0.379,27.733 0,26.728 0,25.68L0,11.852C0,10.804 0.379,9.8 1.054,9.059C1.73,8.318 2.645,7.901 3.6,7.901L23.4,7.901C24.355,7.901 25.27,8.318 25.946,9.059C26.621,9.8 27,10.804 27,11.852L27,25.68C27,26.728 26.621,27.733 25.946,28.473C25.27,29.214 24.355,29.631 23.4,29.631L14.405,29.631L6.581,35.515ZM28.8,19.787C28.794,20.03 28.794,20.273 28.8,20.516L28.8,19.787ZM28.8,19.787C28.808,19.577 28.811,16.93 28.807,11.848C28.806,10.278 28.236,8.772 27.224,7.662C26.211,6.552 24.838,5.928 23.407,5.928L9,5.928L9,3.951C9,2.903 9.379,1.898 10.054,1.157C10.73,0.416 11.645,0 12.6,0L32.4,0C33.355,0 34.27,0.416 34.946,1.157C35.621,1.898 36,2.903 36,3.951L36,17.778C36,18.826 35.621,19.831 34.946,20.572C34.27,21.313 33.355,21.729 32.4,21.729L32.4,26.16C32.394,26.536 32.29,26.902 32.1,27.215C31.911,27.528 31.644,27.776 31.331,27.928C31.018,28.081 30.672,28.132 30.334,28.077C29.995,28.021 29.678,27.86 29.419,27.614L28.8,27.148L28.8,19.787Z",
    fill: "#2D2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector63X2);
export default __webpack_public_path__ + "static/media/vector_63_x2.c91138fa53b6ecbf42031f560566c50c.svg";
export { ForwardRef as ReactComponent };